import React from 'react';
import isTest from '@signal/utils/env/isTest';
import isStorybook from '@signal/utils/env/isStorybook';
import renderIf from '@signal/utils/renderIf';
import { useContexts } from './hooks';
/**
 * @interface IContextLoadableParams
 * this interface defines the parameters that need to be passed to contextLoadable
 */

/**
 * this function generates a loadable for use with the context fetcher
 * @template T - the type defining the properties that can be accepted by the component
 * @param {Array<React.Context>} fetchContexts - the array of fetch contexts
 * @param {React.Component} Component - the component to render if all fetch contexts are loaded
 * @param {React.Component} Skeleton - the component to render if all fetch contexts are not loaded
 * @return {React.FC} - a component which can render the appropriate content depending on whether all fetch contexts
 *   have successfully loaded
 */

export default function contextLoadable(_ref) {
  var fetchContexts = _ref.fetchContexts,
      Component = _ref.Component,
      Loader = _ref.Loader,
      Skeleton = _ref.Skeleton;
  return function (props) {
    var ComponentOrSkeleton = function ComponentOrSkeleton(props) {
      var contexts = useContexts(fetchContexts);
      return /*#__PURE__*/React.createElement(React.Fragment, null, renderIf(Boolean(contexts.every(function (context) {
        return !context.isFetching;
      })), function () {
        return /*#__PURE__*/React.createElement(Component, props);
      }, function () {
        return /*#__PURE__*/React.createElement(Skeleton, props);
      }));
    };

    if (Loader && !isTest() && !isStorybook()) {
      return /*#__PURE__*/React.createElement(Loader, props, /*#__PURE__*/React.createElement(ComponentOrSkeleton, props));
    } else {
      return /*#__PURE__*/React.createElement(ComponentOrSkeleton, props);
    }
  };
}